import 'slick-carousel';

export default {
  init() {
  // JavaScript to be fired on all pages

    jQuery(window).on('scroll', function () {
      var scroll = jQuery(window).scrollTop();

      if (scroll > 0) {
        $('.block-SEO:not(.loaded)').addClass('closed').addClass('loaded');
        $('.block-2col-descripcion-servicio:not(.loaded)').addClass('closed').addClass('loaded');
        jQuery('body').addClass('scrolling');
        jQuery('.list_calltoaction').addClass('fixed-right');
      }else {
        
        jQuery('body').removeClass('scrolling');
        jQuery('.list_calltoaction').removeClass('fixed-right');
        
      }
    });


    //controla los cambios en el menú al hacer click enla ventana, no solo en la x del menú responsive

    jQuery(window).on('click', function (){
    
      if(jQuery('.mega-menu-toggle').is(':visible')){
        var toggle_icon = jQuery('.mega-toggle-animated.mega-toggle-animated-slider');
        var area_expanded  = toggle_icon.attr('aria-expanded');
        var objeto = jQuery('#mega-menu-wrap-primary_navigation .mega-menu-toggle .mega-toggle-block-0 .mega-toggle-animated-inner');
        var logo = jQuery ('#Logo');
        
        if(area_expanded == 'true') {
          jQuery('#cabNav').toggleClass('blueColor');
          objeto.toggleClass('colorWhite');
          logo.toggleClass('pinta_mnu');
          
        }else{
          if(jQuery('#cabNav').hasClass('blueColor')) {
            jQuery('#cabNav').removeClass('blueColor');
            objeto.toggleClass('colorWhite');
            logo.toggleClass('pinta_mnu');
          }
        }
      }
    });
    
/*
    //cambios en menú móvil
    
    jQuery('button.mega-toggle-animated.mega-toggle-animated-slider').on('click',function(e) {
      e.preventDefault();
      var toggle_icon = $(this);
    
      var area_expanded  = toggle_icon.attr('aria-expanded');
      var objeto = jQuery('#mega-menu-wrap-primary_navigation .mega-menu-toggle .mega-toggle-block-0 .mega-toggle-animated-inner');
      var logo = jQuery ('#Logo');
      
      if(area_expanded == 'true') {
        console.log (area_expanded + ' : menu abierto elimina bluecolor colorwhite y pinta mnu')
        if(jQuery('#cabNav').hasClass('blueColor')) {
          jQuery('#cabNav').removeClass('blueColor');
 
          if(objeto.hasClass('colorWhite')) {
            objeto.removeClass('colorWhite');
          }

          if(logo.hasClass('pinta_mnu')) {
            logo.removeClass('pinta_mnu');
          }
        }
      }else{
        console.log (area_expanded + ': menu cerrado añade bluecolor colorwhite y pinta mnu')
        jQuery('#cabNav').addClass('blueColor');
        objeto.addClass('colorWhite');
        logo.addClass('pinta_mnu');
      }
    });
    
*/
    
    //copyright

    var anio_copyright = new Date().getFullYear();
    var selector_anio = jQuery('.footer_navigation .content-footer-nav #menu-menu-info-legal-footer li.nav-item.menu-item:first-child a');
    var selector_anio_escritorio = jQuery('.year_copyright');
    
    if(selector_anio) {
      selector_anio.prepend('<span class="anio_cp">©'+anio_copyright+ ' </span>');
    }

    if(selector_anio_escritorio) {
      selector_anio_escritorio.prepend('<span class="anio_cp">©'+anio_copyright+ ' </span>');
    }

    //bloque seo 
    jQuery('.block-SEO').on('click','a.seo-opener',function(t){
      t.preventDefault(),jQuery(t.target).closest('.block-SEO').removeClass('closed')
    })
    jQuery('.block-SEO').on('click','a.seo-closer',function(t){
      t.preventDefault(),
      jQuery(t.target).closest('.block-SEO').addClass('closed')
    })

    //bloque descripción del servicio
    jQuery('.block-2col-descripcion-servicio').on('click','a.seo-opener',function(t){
      t.preventDefault(),
      jQuery(t.target).closest('.block-2col-descripcion-servicio').removeClass('closed');
      
      if(jQuery('.informacion_servicio.seo-content').hasClass('slide-top')){
        jQuery('.informacion_servicio.seo-content').removeClass('slide-top');
        jQuery('.informacion_servicio.seo-content').addClass('slide-bottom');
      }
    })

    jQuery('.block-2col-descripcion-servicio').on('click','a.seo-closer',function(t){
      t.preventDefault();
     
      if(jQuery('.informacion_servicio.seo-content').hasClass('slide-bottom')){
        jQuery('.informacion_servicio.seo-content').removeClass('slide-bottom');
        jQuery('.informacion_servicio.seo-content').addClass('slide-top');
      }
      jQuery(t.target).closest('.block-2col-descripcion-servicio').addClass('closed')
    })

    //carousel de servicios
    jQuery('.list_servicios.onslider .fila_servicio').slick({
      dots: true,
      infinite: false,
      arrows: false,
      speed: 300,
      autoplay: false,
      slidesToShow: 3,
      slidesToScroll: 3,
      responsive: [
        {
          breakpoint: 992,
          settings: {
            slidesToShow: 2,
            slidesToScroll: 2,
            infinite: false,
            dots: true,
          },
        },
        {
          breakpoint: 768,
          settings: {
            slidesToShow: 2,
            slidesToScroll: 2,
            infinite: false,
            dots: true,
          },
        },
        {
          breakpoint: 540,
          settings: {
            slidesToShow: 2,
            slidesToScroll: 2,
            infinite: false,
            dots: true,
          },
        },{
          breakpoint: 375,
          settings: {
            slidesToShow: 2,
            slidesToScroll: 2,
            infinite: false,
            dots: true,
          },
        },
      ],

    });

    //preguntas frecuentes
    var faq = jQuery('#accordionFAQ');
   
    
    faq.on('show.bs.collapse', function (event) {
      var pregunta = jQuery(event.target).closest('.pregunta');
      var objeto = pregunta.find('.card-header .bto_enunciado');

      if(objeto.hasClass('closer')) {
          objeto.removeClass('closer');
          objeto.addClass('opener')
      }

     /* pregunta.find('.card-header button').trigger('click');*/
      
     if(pregunta.offset().top) {
        setTimeout(function () {
          jQuery('html, body').animate({
            scrollTop: pregunta.offset().top,
          }, 1000);
        }, 1250);
      }
    });
    
    
    faq.on('hide.bs.collapse', function (event) {
      var pregunta = jQuery(event.target).closest('.pregunta');
      var objeto = pregunta.find('.card-header .bto_enunciado');
      
      if(objeto.hasClass('opener')) {
        objeto.removeClass('opener');
        objeto.addClass('closer')
      }

      if(pregunta.offset().top) {
        setTimeout(function () {
          jQuery('html, body').animate({
            scrollTop: pregunta.offset().top,
          }, 1000);
        }, 1250);
      }
    });

 
  },
  finalize() {
    // JavaScript to be fired on all pages, after page specific JS is fired
  },
};



// WEBPACK FOOTER //
// ./scripts/routes/common.js